import { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Tool } from '../../common/components/tool';
import tools, { globalOfferAfterProcessed } from '../../constants/tools';
import { redirectionSteps } from '../../constants/steps';
import { onLeaveTool, onSetRedirectionInfo } from '../reducers/uploadFileReducer';
import i10n from '../../common/i10n';
import { betaKeys, isBetaEnabled } from '../beta';

class OfferAfterProcessedComponent extends PureComponent {

    getToolProposals = () => {
        let tools = [];
        let isErrorRedirection = false;
        if (this.props.offerAfterFail && this.props.offerAfterFail.length) {
            tools = [...new Set(this.props.offerAfterFail)];
            isErrorRedirection = true;
        } else {
            if (this.props.notOfferTools && this.props.notOfferTools.length) {
                globalOfferAfterProcessed.forEach((t) => {
                    if (!this.props.notOfferTools.includes(t.id)) {
                        tools.push(t);
                    }
                })
            } else {
                tools = [...globalOfferAfterProcessed];
            }

            if (this.props.offerTools && this.props.offerTools.length) {
                tools = [...new Set([...tools, ...this.props.offerTools])];
            }
        }

        tools.sort((a, b) => {
            const aNumber = parseInt(a.fillClassName.match(/\d+/)[0], 10);
            const bNumber = parseInt(b.fillClassName.match(/\d+/)[0], 10);
            return aNumber - bNumber;
        });
        
        return {
            tools: tools.slice(0, 6), 
            isErrorRedirection: isErrorRedirection
        };
    }

    render() {
        const { tools, isErrorRedirection } = this.getToolProposals();
        if (!window.embedded && tools.length > 0) {
            let toolOffers = [];

            tools.forEach((t, i) => {
                toolOffers.push(
                    <div key={i} className="col-lg-6 col-xl-4"
                        onClick={() => {
                            if (isErrorRedirection){
                                this.props.setRedirectionInfo(redirectionSteps.beforeRedirection, this.props.toolFiles[0].fileId, t.id, this.props.mainTool ? this.props.mainTool.id : null);
                            } else {
                                this.props.onLeaveTool();
                                this.props.setRedirectionInfo(redirectionSteps.afterRedirection, null, t.id, null);
                            }
                        }}>
                        <Tool tool={t} />
                    </div>
                );
            });

            return (
                <div className="download-offer-tools">
                    <p className="text-center mb-5 sbold">{i10n._VIEW_DOWNLOAD_OFFER_TOOLS}</p>
                    <div className="offer-after-procesed row small-icons">
                        {
                            toolOffers
                        }
                    </div>
                </div>
            );
        } else {
            return (null);
        }

    }
}

const mapState = ({ tool, files }) => {
    return {
        lang: tool.lang,
        toolFiles: files.files,
    };
}

const mapDispatch = (dispatch) => {
    return {
        setRedirectionInfo(step, fileToRedirect, redirectToWidget, mainTool) {
            dispatch(onSetRedirectionInfo(step, fileToRedirect, redirectToWidget, mainTool));
        },
        onLeaveTool() {
            dispatch(onLeaveTool());
        }
    };
}

const OfferAfterProcessed = connect(mapState, mapDispatch)(OfferAfterProcessedComponent);
export default OfferAfterProcessed;